import { type FC } from 'preact/compat';

import { useIntl } from '@/app/lib/localization/hooks/use-intl';

import { useScoreModal } from '@/entities/playdeck/models/playdeck.store';

import { Button } from '@/shared/ui/button/ui';

import s from './index.module.scss';

export const ScoreModal: FC = () => {
  const t = useIntl();
  const scoreModal = useScoreModal();

  if (!scoreModal) return null;

  return (
    <div className={s.overlay}>
      <div className={s.card}>
        <span className={s.label}>{t('Your score')}</span>
        <span className={s.score}>{scoreModal.score}</span>
        <Button className={s.button} onClick={scoreModal.resolve}>
          {t('Play again')}
        </Button>
      </div>
    </div>
  );
};
